import React from 'react';

export default function LibTile(props) {
  return <div className="mdl-cell mdl-card mdl-shadow--4dp portfolio-card">
    <div className="mdl-card__title">
      <h2 className="mdl-card__title-text">{props.title}</h2>
    </div>
    <div className="mdl-card__supporting-text">
      {props.desc}
    </div>
    <div className="mdl-card__actions mdl-card--border">
      <a className="mdl-button purple-button mdl-button--colored mdl-js-button mdl-js-ripple-effect mdl-button--accent" href={`https://www.npmjs.com/package/${props.title.toLowerCase()}`}>Read more</a>
    </div>
  </div>
}



// WEBPACK FOOTER //
// ./src/LibTile/LibTile.js